import cl from "clsx";
import React from "react";
import { PlusIcon } from "@navikt/aksel-icons";
import { BodyShort, Label } from "../../../typography/index.js";
import { useInputContext } from "../Input/Input.context.js";
import { useSelectedOptionsContext } from "../SelectedOptions/selectedOptionsContext.js";
import { isInList, toComboboxOption } from "../combobox-utils.js";
import filteredOptionsUtil from "./filtered-options-util.js";
import { useFilteredOptionsContext } from "./filteredOptionsContext.js";
const AddNewOption = () => {
    const { inputProps: { id }, size, value, } = useInputContext();
    const { setIsMouseLastUsedInputDevice, toggleIsListOpen, activeDecendantId, virtualFocus, } = useFilteredOptionsContext();
    const { isMultiSelect, selectedOptions, toggleOption } = useSelectedOptionsContext();
    return (React.createElement("li", { tabIndex: -1, onMouseMove: () => {
            if (activeDecendantId !== filteredOptionsUtil.getAddNewOptionId(id)) {
                virtualFocus.moveFocusToElement(filteredOptionsUtil.getAddNewOptionId(id));
                setIsMouseLastUsedInputDevice(true);
            }
        }, onPointerUp: (event) => {
            toggleOption(toComboboxOption(value), event);
            if (!isMultiSelect && !isInList(value, selectedOptions))
                toggleIsListOpen(false);
        }, id: filteredOptionsUtil.getAddNewOptionId(id), className: cl("navds-combobox__list-item navds-combobox__list-item--new-option", {
            "navds-combobox__list-item--new-option--focus": activeDecendantId === filteredOptionsUtil.getAddNewOptionId(id),
        }), role: "option", "aria-selected": false },
        React.createElement(PlusIcon, { "aria-hidden": true }),
        React.createElement(BodyShort, { size: size },
            "Legg til",
            " ",
            React.createElement(Label, { as: "span", size: size },
                "\u201C",
                value,
                "\u201D"))));
};
export default AddNewOption;
//# sourceMappingURL=AddNewOption.js.map